/* Billing & usage. Facts with their source printed beside them; nothing here is a control, a price
   or an amount owed, and the stylesheet has no class for any of them. Tokens only (ADR-0007). */

/* A phone is narrower than four columns: the table scrolls in its own region rather than widening the
   screen's body. */
.scroll {
  max-width: 100%;
  overflow-x: auto;
}

.facts {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
}

.fact > th,
.fact > td {
  padding: 8px 12px 8px 0;
  vertical-align: baseline;
  text-align: start;
  border-top: 1px solid var(--line);
  min-width: 0;
}

.label {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.value {
  color: var(--ink);
  font-size: var(--t-body);
  font-variant-numeric: lining-nums tabular-nums;
  overflow-wrap: anywhere;
}

.mix {
  color: var(--ink-2);
  font-size: var(--t-dense);
}

.detail {
  color: var(--ink-2);
  font-size: var(--t-dense);
  overflow-wrap: anywhere;
}

.source {
  color: var(--muted);
  font-size: var(--t-min);
}

/* Try again, beside the sentence that says the contact address could not be read: a failure with no
   way to ask again is a dead end (E2E P9). Quiet, because a repair is not a decision. */
.retry {
  padding: 0 8px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink-2);
  font: inherit;
  font-size: var(--t-min);
  cursor: pointer;
}

.retry:hover {
  background: var(--panel-2);
  color: var(--ink);
}
